import { hfbXxxStringTranslator } from "@coworker/locales";

type DepartmentOption = {
  value: string;
  name: string;
};

type TranslateFn = (
  key: string,
  params?: {
    hfb: string;
  }
) => string;

type GetHfbForDisplayParams = {
  hfb?: string | null;
  options: DepartmentOption[];
  t: TranslateFn;
};

export function getHfbForDisplay({
  hfb,
  options,
  t,
}: GetHfbForDisplayParams): string | null {
  if (!hfb) {
    return null;
  }

  const hfbNumber = hfb.match(/^HFB\s+(\d{1,2})$/)?.[1] ?? hfb;
  const normalizedHfb = hfbNumber.padStart(
    /^\d{1,2}$/.test(hfbNumber) ? 2 : 0,
    "0"
  );
  const hfbOption = options.find(
    (option) => option.value === hfb || option.value === `HFB ${normalizedHfb}`
  );

  if (hfbOption?.name) {
    return hfbOption.name;
  }

  return /^\d{2}$/.test(normalizedHfb)
    ? `${t("hfbFilterOptionString", { hfb: normalizedHfb })} - ${hfbXxxStringTranslator(normalizedHfb, t)}`
    : hfbXxxStringTranslator(normalizedHfb, t);
}
